import React from "react";
import { useParams, Navigate } from "react-router-dom";

/**
 * @returns {React.ReactElement} Redirect to org overview
 */
export default function OrgIndex() {
  const { orgId } = useParams();

  return <Navigate to={`/orgs/${orgId}/overview`} />;
}
